import React, { useEffect, useState } from 'react';
import logo from '../../images/laughing_tiger_logo.svg';

// hadaka.jp のローディングを参考にした演出。
// 黒背景がフェードインし、ロゴ表示後にフェードアウトしてページを露出させる。
const ENTER_AT = 60;    // ロゴ/テキストのフェードイン開始
const EXIT_AT = 1500;   // 退場アニメーション開始
const DONE_AT = 2400;   // DOM から取り除くタイミング

function Loader({ onDone }) {
  const [phase, setPhase] = useState('');

  useEffect(() => {
    document.body.classList.add('is-loading');

    const timers = [
      setTimeout(() => setPhase('show'), ENTER_AT),
      setTimeout(() => setPhase('hide'), EXIT_AT),
      setTimeout(() => {
        document.body.classList.remove('is-loading');
        onDone();
      }, DONE_AT),
    ];

    return () => {
      timers.forEach(clearTimeout);
      document.body.classList.remove('is-loading');
    };
  }, [onDone]);

  return (
    <div className={`loaderwrap ${phase}`} aria-hidden="true">
      <div className={`loader ${phase}`}>
        <div className="loaderc">
          <img src={logo} className="logoloader" alt="" />
          <p>
            <span>TAIGA KISHIMOTO</span>
            <span>PORTFOLIO</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Loader;
